import {fields as basicFields} from "../basic_fields.js";
import {CalculatorComplex} from "./calc_complex.js";
import {createOutputField} from "./output_fields.js";
export {ShowErrorWay} from "./utils.js";


/**
 * TODO: Move inline-radio to web-component
 * TODO: Move datetime-segment elem to web-component
 * 
 * */
export class Calculator extends CalculatorComplex {

    constructor() {
        super();
        this._fieldTypes = basicFields;
        this.showVersionBanner = ShowVersionBanner;
        this.setupVersionBanner();
        this.setupHandlers();
        this.autoAddFields();
        this.initialize();
        this.forceRender();
    }
    
    log(...args) {
        if (this.debug) {
            console.log(...args);
        }
    }

    setupVersionBanner() {
        if(this.showVersionBanner){
            $('.old-version-alert')?.show();
            $('.old-version-alert')?.find('.close-button')?.click(function () {
                $('.old-version-alert').slideUp(200);
            });

            $('.new-version-alert')?.show();
            $('.new-version-alert')?.find('.close-button')?.click(function () {
                $('.new-version-alert').slideUp(200);
            });
        }
    }

    setupHandlers() {
        const self = this;
        $("#printResult").click(function () {
            if (self.isActive){
                window.print();
                const message = self._statistic.printMessage;
                self.sendStatisticMessage(typeof(message) === "function" ? message() : message);
            }
            return false;
        });

        $("#wordResult").click(function () {
            if (self.isActive) {
                const formData = new FormData();
                formData.append("calcType", self.type());
                formData.append("json", JSON.stringify(self._exportObjectFinal));

                $.ajax({
                    url: ExportWordHost,
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    cache: false,
                    xhr:function(){
                        var xhr = new XMLHttpRequest();
                        xhr.onloadstart = function(ev) {
                            xhr.responseType = "blob";
                        };
                        return xhr;
                    },
                    success: function(response, textStatus, jQxhr) {
                        const name = decodeURI(jQxhr.getResponseHeader("Content-Disposition").split("filename*=UTF-8''")[1]);
                        const blob = new Blob([response], {type:"application/ms-word"});
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveOrOpenBlob(blob, name);
                        } else {
                            const link = document.createElement("a");
                            link.download = name;
                            link.href =  URL.createObjectURL(blob);
                            link.click();  
                        }
                        return true;
                    }, 
                 });

                const message = self._statistic.exportMessage;
                self.sendStatisticMessage(typeof(message) === "function" ? message() : message);
            }
            return false;
        });

    }
    /**
     * 
     * @param {string} hash - place where need to redirect
     */
    setHash(hash){
        if (hash)
            window.location.hash = hash;
        else
            window.history.pushState("", document.title, window.location.pathname);
    }

    checkHash(hash) {
        const currentHash = this.getHash();
        return currentHash.match(new RegExp(`^${hash}$`));
    }

    getHash() {
        return document.location.hash.substring(1);
    }

    autoSubmit(sender, skipValueChangesCheck) {
        sender = sender || null;
        this.submitForm(sender, false, skipValueChangesCheck);
    }
    
    autoAddFields() {
        const fields = this.fetchFields();
        fields.inputs.forEach(args => { if (args !== null) this.addInputField(...args); });
        fields.outputs.forEach(args => { if (args !== null) this.addOutputField(...args); });
    }

    loadDescription(feedbackBottom = true) {
        const self = this;
        return new Promise(function (resolve, reject) {
            $("#calcDescription").load("/conf/calc_"+self.code()+"/promo.html?v=" + DataVersionSalt, function () {
                $(".smart-link").each(function () {
                    tools.initSmartLink(this);
                });

                tools.setWarningMessage(this);

                if (!IsAuthEnabled) {
                    const mailSubject = `<a href="mailto:calc@consultant.ru?subject=Калькулятор ${$("#calcHeader").html()}: обратная связь" ${feedbackBottom ? "style=\"float:right;\"" : ""}>Обратная связь</a>`;
                    if (feedbackBottom) {
                        $(".calc-div-input-footer").append($(mailSubject));
                    }
                    else {
                        $("#calcDescription").prepend($(`<div style="margin-bottom: 22px;font-size: 15px;line-height: 20px;">${mailSubject}</div>`));
                    }
                }
                resolve();
            });
        });
    }

    patchFieldTypes(newFieldTypes) {
        this._fieldTypes = this._fieldTypes.concat(newFieldTypes);
    }

    showResults() {
        $(".calc-div-results").addClass("show-results");
    }

    hideResults() {
        $(".calc-div-results").removeClass("show-results");
    }

    generateExportObject() {
        return this._exportObject;
    }

    get defaultFilled(){
        return false;
    }

    /**
     * Sets up part which works with statistic
     * @param {object} params
     *      - calcName (required) uses in message gen
     *      - prefix ('Calculation_' by default) uses in message gen
     *      - printMessage ('Print' by default) you can use object here (@see {sendStattisticMessage}) or even function which returns string_or_object
     *      - exportMessage ('Export' by default) the same as previous but for export
     */
    setupStatistic(params) {
        params = params || {};
        this._statistic = params;
        this._statistic.startedSent = params.isStartedEventIgnore || false;
        if (this._statistic.prefix === undefined)
            this._statistic.prefix = "Calculation_";

        if (this._statistic.printMessage === undefined)
            this._statistic.printMessage = "Print";

        if (this._statistic.exportMessage === undefined)
            this._statistic.exportMessage = "Export";
    }

    /**
     * Sends statistic message
     * @param {any} string_or_object
     * If this value is object it could contain next props:
     *      - message (required)
     *      - args, if you need to send additional arguments
     *      - prefix, if you need to redefine prefix for specific stat message
     * Otherwise it uses like an object with only `message` prop filled
     */
    sendStatisticMessage(string_or_object) {
        let params = string_or_object;
        if (typeof (string_or_object) === "string") { 
            params = {
                message: string_or_object
            };
        }
        const prefix = params.prefix !== undefined ? params.prefix : this._statistic.prefix;

        if (this._statistic.calcName === undefined) {
            console.warn("Calculator's name is not set up. Use method `setupStatistic` for it.");
        }

        ym(ymId, ymReachGoal, prefix + params.message + "_" + this._statistic.calcName, params.args);
    }

    submitOnClick(selectorOrElem) {
        var self = this;
        $(selectorOrElem).click(function () { self.submitForm(null, false, true); });
    }

    submitOnChange() {
        this._submitOnChange = true;
    }

    addResetButton(selector, hideOnDefault) {
        hideOnDefault = hideOnDefault === undefined ? true : hideOnDefault;
        var self = this;
        var elem = $(selector);
        elem.click(function () {
            if (self.isActive){
                self.resetInputFields();
                self.sendStatisticMessage("Default");
            }
        });
        if (hideOnDefault) {
            this.resetButtons.push(elem);
        }
    }

    removePathId(path) {
        return path.replace(/[:]\d+/g, "");
    }

    clearPath(obj, path) {
        const parts = path.split(".");
        const part0 = parts[0];
        obj[part0.replace(/\[|\]/g, "")] = undefined;
    }

    /**
     * Checks that path inside srcPath
     * @param {object} obj
     * @param {string} path
     * @param {string} srcPath
     */
    isPathInside(path, srcPath) {
        return (path.indexOf(srcPath + ".") == 0 || path.indexOf(srcPath + "[]") == 0 || path === srcPath);
    }

    /**
     * Method for adding input fields (instead of parsing form)
     * @param {stringOrElement} selector
     * @param {string} name (where value saves: this.<name>)
     * @param {Object} params has next keys:
     *      - type - one of (money, int). Some can be detected automatically ()
     *      - defaultValue - (for reseting)
     *      - errClassElem - (optional, set it if it's requires to add err class not to $(selector) elem but to different)
     *      - showErrorWay - (optional - redefines global setting)
     *      - disableAutoCheck - (optional - otherwise will check on change)
     *      - errors - list of objects {check: func(v), selector: strOrElem, errClassElem: strOrElem[optional]}
     *      - options - for some fieldTypes this options is useful
     *      - preInit - (optional, will be called before init call)
     *      - unsilence - (optional - array of other field names that would have non-silent check when this field is a sender)
     */
    addInputField(selector, name, params) {
        params = params || {};
        const self = this;

        if (params.dynamic) {
            params.table = selector;
            return this.addDynamicField(name, params);
        }

        const elem = $(selector);
        const ftype = params.type === undefined ? this._detectFieldType(elem) : params.type;
        const field = this._makeFieldObject(elem, ftype, params.options);
        params.showErrorWay = params.showErrorWay || self.showErrorWay;
        field.params_ = params;
        field.varName = name;
        field.name = self.removePathId(name);
        field.defaultValue = (params.defaultValue === undefined ? field.getClearValue() : params.defaultValue);

        if (!params.disableAutoCheck) {
            field.onChange(function (sender) {
                if (!params.disabledSubmitting) {
                    self.submitForm(sender, !self._submitOnChange);
                }
            });
        }

        if (params.preInit !== undefined)
            params.preInit(field);

        field.init();

        this.inputFields.push(field);
        return field;
    }

    _detectFieldType(elem) {
        var result = undefined;
        this._fieldTypes.some(function (ft) {
            if (ft.detect(elem)) {
                result = ft.keyName();
                return true;
            }
        });
        if (result === undefined) {
            console.error("Can't detect field type", elem);
        }
        return result;
    }

    _makeFieldObject(elem, fieldType, options) {
        var result = undefined;
        if (!this._fieldTypes.some(function (ft) {
            if (ft.keyName() === fieldType) {
                result = new ft(elem, options);
                return true;
            }
        })) {
            console.error("Can't find class for field type", fieldType, "of element", elem);
        }
        return result;
    }
    
    /**
     * Parses group with internal checks (between elements inside group)
     * @param {any} group
     */
    processGroup(group, sender, autoValidation) {
        const result = group.check(sender, autoValidation);
        if (result.artifacts !== undefined) {
            for (const key in result.artifacts) {
                this[key] = result.artifacts[key];
            }
        }
        return result.valid;            
    }
    
    resetInputFields(params) {
        const self = this;
        if (!this.isActive) return;
        params = params || {};
        this.inputFields.forEach(function (f) {
            if (params.fields === undefined || params.fields.some(f => self.isPathInside(f.name, f)))
                f.reset(params);
        });
        this.lastValuesString = "";

        this._dynamicFields.map((item) => item.reset());
        this.onReset();
        this.forceRender();

        this.resetButtons.forEach(function (elem) {
            elem.hide();
        });
    }

    /**
     * Method for rendering from variables (instead of render function)
     * @param {any} selector
     * @param {any} name
     * @param {any} params
     * @param {any} forced
     */
    addOutputField(selector, name, params, forced = false) {
        const field = createOutputField(this, selector, name, params);
        this.outputFields.push(field);
        if (forced)
            this.forceOutputs.push(field);
        return field;
    }

    render() {
        const self = this;
        const orderedFields = this.outputFields.map(x => x);
        const priorities = orderedFields.map(f => f.get("priority", 0));
        if (priorities.length > 0 && priorities.some(x => x != priorities[0]))
            orderedFields.sort((a, b) => a.get("priority", 0) - b.get("priority", 0));
        orderedFields.forEach(function (field) {
            field.render(self);
            field.renderExport(self._exportObject.render);
        });
    }

    forceRender() {
        this.forceOutputs.forEach((field) => {
            field.render(this);
        });
    }

    toggleCustomClasses() {
        this.toggleClasses.map(customClass => {
            customClass.toggle();
        });
    }

    renderError() {
        if (!this._submitOnChange) {
            $(".calc-div-results").removeClass("show-results");
        }
    }
    
    autoValidate(sender) {
        sender = sender || null;
        this.submitForm(sender, true);
    }
    
}